<div class="container-fluid mb-4" style="height: 100%; margin: 0 !important">
  <div class="menu-mobile d-xl-none">

    <button class="btn gl-button-primary gl-text-contrast" (click)="toggleMenu()" >

      <i class="pi pi-bars"></i> <!-- Icono de hamburguesa -->
    </button>

    <div
      *ngIf="isMenuOpen"
      class="custom-menu border gl-secondary-background gl-border ml-2"
    >
      <ul>
        <li *ngFor="let item of items">

          <div class="row">
            <div class="col-12 sub-container-menu">
              <i class="pi" [ngClass]="item.icon"></i>
              <span>{{ item.label }}</span>
            </div>
            <div class="col-12">
              <!-- Subopciones -->
              <ul *ngIf="item.items" class="sub-menu">
                <li *ngFor="let subItem of item.items"
                    [ngClass]="{'active': selectedSubItem === subItem.label}"
                    (click)="onSubItemSelect(subItem)">
                  <i class="pi" [ngClass]="subItem.icon"></i>
                  <span>{{ subItem.label }}</span>
                </li>
              </ul>
            </div>
          </div>

        </li>
      </ul>
    </div>
  </div>

  <div class="row" style="height: 100%">
    <div class="col-3 positivo-relative d-flex d-none d-xl-block">
      <!-- menu -->
      <div class="custom-menu ml-2">
        <ul>
          <li *ngFor="let item of items">

            <div class="row">
              <div class="col-12 sub-container-menu">
                <span>{{ item.label }}</span>
              </div>
              <div class="col-12">
                <!-- Subopciones -->
                <ul *ngIf="item.items" class="sub-menu">
                  <li *ngFor="let subItem of item.items"
                      [ngClass]="{'active': selectedSubItem === subItem.section}"
                      (click)="onSubItemSelect(subItem)">
                    <i class="pi" [ngClass]="subItem.icon"></i>
                    <span>{{ subItem.label }}</span>
                  </li>
                </ul>
              </div>
            </div>

          </li>
        </ul>
      </div>
    </div>
    <div class="col-12 col-xl-9 mt-5 mt-xl-0 scroll-container" [ngSwitch]="selectedSection">
      <app-user-history-config *ngSwitchCase="configSections.HISTORY_CONFIG"></app-user-history-config>
      <app-user-profile-info *ngSwitchCase="configSections.USER_PROFILE"></app-user-profile-info>
      <app-user-password-update *ngSwitchCase="configSections.PASSWORD_CHANGE"></app-user-password-update>
      <app-user-icons-config *ngSwitchCase="configSections.ICONS_CONFIGURATION"></app-user-icons-config>
      <app-user-platform-info *ngSwitchCase="configSections.PLATFORM_INFO"></app-user-platform-info>
      <app-user-theme-config *ngSwitchCase="configSections.THEME_CUSTOM"></app-user-theme-config>
      <app-user-panel-visibility *ngSwitchCase="configSections.VIEWS_PREFERENCES"></app-user-panel-visibility>
      <app-user-lenguage-config *ngSwitchCase="configSections.LENGUAGE_CONFIGURATION"></app-user-lenguage-config>
      <app-user-vehicle-config *ngSwitchCase="configSections.VEHICLE_CONFIG"></app-user-vehicle-config>
      <app-user-alert-config *ngSwitchCase="configSections.ALERT_CONFIG"></app-user-alert-config>
      <app-user-geofences-config *ngSwitchCase="configSections.GEOFENCE_CONFIG"></app-user-geofences-config>
      <app-user-geopoints-config *ngSwitchCase="configSections.GEOPOINTS_CONFIG"></app-user-geopoints-config>
      <app-user-events-config *ngSwitchCase="configSections.EVENTS_CONFIG"></app-user-events-config>
      <app-user-drivers-config *ngSwitchCase="configSections.DRIVERS_CONFIG"></app-user-drivers-config>
      <app-user-footbar-config *ngSwitchCase="configSections.FOOTBAR_CONFIG"></app-user-footbar-config>
      <app-user-card-vehicle *ngSwitchCase="configSections.CARD_VEHICLES"></app-user-card-vehicle>
      <app-user-history-drawer *ngSwitchCase="configSections.HISTORY_DRAWER_CONFIGURATION"></app-user-history-drawer>
    </div>
  </div>
</div>
